import { EpimsBaseEntityDto } from './epim-base.dto';
export class LessorRepTypeDto extends EpimsBaseEntityDto {
  LessorRepName: string;
  SubscriptionUserId: string;
  Version: number;
}
